<template>
  <v-row class="px-0 mt-10">
    <v-col cols="auto" class="my-3 py-0 px-1 blogs-header card-border-radius">
      <h2 data-testid="popular-blogs-heading" class="font-weight-bold text-center">
        Popular Blogs
      </h2>
    </v-col>
    <v-col
        cols="12"
        v-if="!loading && hasData"
        data-testid="blogs-list"
        class="card-border-radius d-flex flex-column pa-10"
        style="background-color: #FFFFFF;"
    >
      <div class="d-flex flex-row flex-wrap justify-space-between" >
        <BlogCard
          v-for="(blog,index) in blogs"
          :key="blog.slug"
          :blog="blog"
          :card-width="index === 0 ? '48%' : '23%'"
          :card-image="index === 0 || index === 3"
          :latest-blog="index === 0"
        />
      </div>
    </v-col>
    <v-col cols="12" v-if="!loading">
      <infinite-loading spinner="waveDots" @infinite="fetchMoreBlogs">
        <div slot="no-results">
          <v-chip small text-color="primary">You have caught up</v-chip>
        </div>
        <div slot="no-more">
          <v-chip small text-color="primary">You have caught up</v-chip>
        </div>
      </infinite-loading>
    </v-col>
     <v-col cols="12" v-if="(!loading && !hasData)" class="bottom-wrapper">
      <NoData
          data-testid="empty-blogs-list"
          :image="emptyPage"
          :title="`No blogs published yet`"
      />
    </v-col>
    <v-col cols="12" v-if="loading" class="d-flex flex-row flex-wrap justify-space-around">
      <v-skeleton-loader
          data-testid="v-skeleton-loader"
          v-for="x in 9"
          :key="x"
          class="my-3"
          type="card,article,list-item-avatar-three-line"
          :width="$vuetify.breakpoint.xs ? '99%' : '30%'"
      />
    </v-col>
  </v-row>
</template>
<script>

import {mapGetters, mapMutations} from "vuex";
import Logo from "@/assets/guiomentorLogo.png";
import BlogCard from "@/components/BlogCard";
import emptyPage from "@/assets/no_data.svg";
import NoData from "@/components/NoData";
import InfiniteScroll from "@/mixins/InfiniteScroll";

export default {
  mixins: [InfiniteScroll],
  metaInfo() {
    return {
      title: 'Guiomentor - Popular Blogs',
      url: window.location.href,
      meta: [
        {name: 'title', content: 'Guiomentor - Blogs'},
        {
          name: 'description',
          content: this.description
        },
        //Facebook
        {name: 'og:type', content: 'Website'},
        {name: 'og:title', content: "Guiomentor - Blogs"},
        {name: 'og:description', content: this.description},
        {name: 'og:image', content: this.logo},

        // Twitter
        {name: 'twitter:card', content: 'summary_large_image'},
        {name: 'twitter:url', content: window.location.href},
        {name: 'twitter:title', content: "Guiomentor - Blogs"},
        {name: 'twitter:description', content: this.description},
        {name: 'twitter:image', content: this.logo},
      ]
    }
  },
  components: {BlogCard, NoData},
  data: () => ({
    emptyPage,
    showLogOutDialog: false,
    drawerOpen: true,
    limit: 5,
    offset: 5,
    loading: false,
    fetchUrl: "",
    logo: Logo,
    description: "Guiomentor is a platform directed to a niche of 10to 25 years old. Its objective is to help students to choose the best career or discipline for them according to their skills and part of interest "

  }),
  beforeMount() {
    this.fetchUrl = `blogs/posts/?limit=${this.limit}&order_by=blog_views`
    this.SET_POPULAR_BLOGS([])
    this.loadBlogs()
  },
  computed: {
    ...mapGetters({
      user: "auth/GET_USER",
      blogs: "blogs/GET_POPULAR_BLOGS"
    }),
    hasData() {
      return Boolean(this.blogs.length)
    },
  },
  methods: {
    ...mapMutations({
      SET_POPULAR_BLOGS: "blogs/SET_POPULAR_BLOGS"
    }),
    async loadBlogs() {
      try {
        this.loading = true
        const {data} = await this.axios.get(this.fetchUrl)
        this.SET_POPULAR_BLOGS(data.results)
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$snackbar.showMessage({
          content: this.$t('errors.somethingWentWrongError'),
          color: "error",
        });
      }
    },
    fetchMoreBlogs($state) {
      this.infiniteHandler($state, "SET_POPULAR_BLOGS")
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";
.blogs-header {
  background-color: #FFFFFF;
  color: #0035B0;
}
.card-border-radius {
  border-radius: .5em;
}
.v-btn {
  text-transform: none !important;
  padding: 1.5em !important;
  font-size: 1.2em !important;
}
</style>
